import { Handle, Position } from "reactflow";
import { mdiFilterOutline } from "@mdi/js";
import Icon from "@mdi/react";
import NoteTooltip from "../misc/NoteTooltip";

export default function FilterNode({ data }) {
  return (
    <div className="FilterNode">
      <Handle
        className="PlaybookHandle"
        type="target"
        position={Position.Top}
        isConnectable={false}
      />

      <div className="FilterNodeIcon">
        <svg
          width="100"
          height="90"
          viewBox="0 0 152 152"
          className="svg-icon "
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            transform="rotate(180 76 76) translate(0 12)"
            d="M70.8901 3.30366C73.233 -0.503561 78.767 -0.503551 81.11 3.30367L150.373 115.855C152.833 119.853 149.957 125 145.263 125H6.73738C2.04346 125 -0.832637 119.853 1.62744 115.855L70.8901 3.30366Z"
            strokeWidth="3px"
          ></path>
        </svg>
        <div className="FilterNodeInnerIcon">
          <Icon size={1.1} path={mdiFilterOutline} color="white"></Icon>
          <div style={{ marginRight: "10px", marginTop: "-30px" }}>
            {data.advanced.note ? (
              <NoteTooltip title={data.advanced.note}></NoteTooltip>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <Handle
        className="PlaybookHandle"
        type="source"
        position={Position.Bottom}
        id="a"
        isConnectable={false}
      />
    </div>
  );
}
